// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2dLc7","author":"Table_author__2bKBB","authorImage":"Table_authorImage__2XPMX","unreadRow":"Table_unreadRow__3GA0p"};